import {
  ADEBIFY_PRODUCT_ANALYSIS,
  ADEBIFY_LTV_DETAIL,
  ADEBIFY_LTV_COHORT,
  ADEBIFY_CUSTOM_REPORT,
} from 'services/routes/constants';
import { DEFAULT_ADEBIFY_AXIS } from 'domain/adebify/screenFilterKeys';

// Resolve the priority axis used by FilterSelectionMenu so it matches the axis
// already used by each screen's getAdebify*FilterKeys helper (FilterService).
const resolveAdebifyFilterPriorityAxis = (
  pageId,
  filterContext,
  globalPriorityAxis
) => {
  switch (pageId) {
    case ADEBIFY_PRODUCT_ANALYSIS:
      return (
        filterContext.adebifyProductAnalysisAxis ||
        globalPriorityAxis ||
        DEFAULT_ADEBIFY_AXIS
      );
    case ADEBIFY_LTV_DETAIL:
      return filterContext.adebifyLtvDetailAxis || DEFAULT_ADEBIFY_AXIS;
    case ADEBIFY_LTV_COHORT:
      return filterContext.adebifyLtvCohortAxis || DEFAULT_ADEBIFY_AXIS;
    case ADEBIFY_CUSTOM_REPORT:
      return filterContext.adebifyCustomReportAxis || DEFAULT_ADEBIFY_AXIS;
    default:
      return globalPriorityAxis;
  }
};

export default resolveAdebifyFilterPriorityAxis;
